import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

import TagManager from "react-gtm-module";

TagManager.initialize({
  gtmId: "GTM-FVTCBJ3M",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
